import React from "react";
import styled from 'styled-components';
import Layout from "./../components/Layout/Layout";

const PageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  text-align: center;
`;

const CampaignDescription = styled.p`
  font-size: 1.2em;
  line-height: 1.6;
  margin-bottom: 30px;
`;
const Donation = () => {
    const goFundMeUrl = "https://gofund.me/278a2f43"; // Replace with your actual GoFundMe URL

    return (
        <Layout>
            <PageContainer>
                <CampaignDescription>
                    We are raising funds to improve accessibility to the sport for local kids. Your contributions will help us reach our goal and make a difference. Click the button below to donate through our GoFundMe campaign.
                </CampaignDescription>
                <GoFundMeLink campaignUrl={goFundMeUrl} />
            </PageContainer>
        </Layout>
    );
}

const Button = styled.a`
  display: inline-block;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: #28a745;
  border-radius: 5px;
  text-decoration: none;
  text-align: center;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #218838;
  }
`;

const GoFundMeLink = ({ campaignUrl }) => {
    return (
        <Button href={campaignUrl} target="_blank" rel="noopener noreferrer">
            Donate on GoFundMe
        </Button>
    );
};
export default Donation